// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"cb1d94d9","453":"5be6d024","948":"5f2a7ab4"}[chunkId] + ".chunk.js";
};